<template>
    <div>
      <QueryFrame
        add-text=""
        :count="count"
        :current="page"
        @handlePage="handlePage"
        @handlePageSize="handlePageSize"
        :showQuery="this.isSuperRole()">
        <div slot="queryParams">
          <div class="historyContainer">
            <div class="queryItem">
              <label>操作名称:</label>
              <operationListSelect class="item" v-model="query.operCategory" :multiple='true'></operationListSelect>
            </div>
            <div class="queryItem">
              <label>操作人:</label>
              <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.createUserName"></lk-input>
            </div>
            <div class="queryItem">
              <label>门店:</label>
              <storeListSelect class="item" v-model="query.storeIdList" :multiple='true'></storeListSelect>
            </div>
            <div class="queryItem">
              <lk-button class="mr" type="primary" @click="searchData">查询</lk-button>
              <lk-button @click="handleReset">重置</lk-button>
            </div>
          </div>
        </div>
        <div slot="table">
          <div class="btn-wrap">
            <DownloadButton class="mb16" @on-click="downloadExcel"></DownloadButton>
          </div>
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </div>
      </QueryFrame>
    </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import history from '../../services/history';
import DownloadButton from '../../components/download/DownloadButton';
import operationListSelect from '../../components/OperationListSelect.vue';

export default {
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    operationListSelect,
  },
  data() {
    return {
      downloadP: {},
      query: {},
      operCategoryCodes: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '操作时间',
          key: 'createTime',
          width: 130,
          render: (h, { row }) => h('span', utils.exchangeTimeToSecond(row.createTime)),
        },
        {
          title: '操作人',
          key: 'createUserName',
          width: 100,
        },
        {
          title: '操作名称',
          key: 'operCategoryName',
          minWidth: 116,
        },
        {
          title: '操作内容',
          key: 'content',
          minWidth: 188,
        },
        {
          title: '菜单位置',
          key: 'menuLoc',
          minWidth: 188,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      this.query.page = this.page;
      this.query.size = this.size;
      this.$store.commit('setDisableLoading', true);
      this.downloadP = utils.deepClone(this.query);
      history.getOperationHistoryList(this.query).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downloadExcel() {
      this.$delete(this.downloadP, 'page');
      this.$delete(this.downloadP, 'size');
      if (this.isSuperRole()) {
        this.downloadP.queryCondition = utils.getQueryCondition('.historyContainer');
      }
      history.exportFile(this.downloadP).then(() => {
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {};
    },
    searchData() {
      this.page = 1;
      this.size = 20;
      this.getData();
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    isSuperRole() {
      const currentRoleIds = [];
      this.$store.state.user.roles.forEach((item) => {
        currentRoleIds.push(item.id);
      });
      if (currentRoleIds.includes(17)) { // 系统管理员
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.isSuperRole()) {
      this.columns.splice(2, 0, {
        title: '门店',
        key: 'storeName',
        minWidth: 116,
      });
    }
    this.getData();
  },
};
</script>
<style lang="less" scoped>
  .historyContainer{//样式写进公共类中
    display: flex;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 12.5px;
      >label{
        padding-right: 8px
      }
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
